<template>
  <SModalComponent
    v-model="showModal"
    :options="{
      onClose: closeModal,
    }"
  >
    <template #header>
      <div>
        <h1 class="text-lg font-bold">Assinatura Bloqueada</h1>
      </div>
    </template>
    <section>
      <div class="p-6 text-center max-w-[520px] mx-auto">
        <div class="w-20 h-20 rounded-full bg-gray-100 mx-auto flex items-center justify-center mb-4">
          <Lock class="absolute text-gray-400" size="38" />
        </div>

        <h3 class="text-2xl font-semibold mb-2">Acesso Restrito</h3>
        <p class="text-gray-500 mb-5 text-justify">{{ assinaturaStore.blockedModalMotivo }}. Para utilizar as funcionalidades da plataforma, é necessário regularizar sua assinatura.</p>

        <div class="bg-blue-50 border border-blue-200 rounded-custom px-4 py-4 mb-4">
          <p class="text-blue-900 font-semibold">Cadastre um novo cartão de pagamento para ter acesso completo.</p>
        </div>

        <div class="mb-3">
          <button @click="corrigirInformacoesPagamento" class="bg-black text-white px-6 py-3 rounded w-full max-w-sm mx-auto flex gap-1 justify-center items-center">Corrigir informações de pagamento <ExternalLink size="20" /></button>
        </div>

        <p class="text-xs text-gray-500">Para continuar usando o sistema, sua assinatura precisa estar regularizada.</p>
      </div>
    </section>
  </SModalComponent>
</template>
<script setup>
import { computed, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useSessionStore } from '@/stores/components/sessionStore.js'
import { useAssinaturaStore } from '@/stores/components/assinaturaStore'
import SModalComponent from '@/components/globals/SModalComponent/SModalComponent.vue'
import { ExternalLink, Lock } from 'lucide-vue-next'

const router = useRouter()
const sessionStore = useSessionStore()
const assinaturaStore = useAssinaturaStore()

const showModal = computed({
  get() {
    return !!assinaturaStore.showBlockedModal && !!sessionStore.isSubscriptionBlocked
  },
  set(value) {
    if (!value) assinaturaStore.closeBlockedModal()
  },
})

// Se a assinatura deixar de estar bloqueada, garante que a modal feche.
watch(
  () => sessionStore.isSubscriptionBlocked,
  (val) => {
    if (!val) assinaturaStore.closeBlockedModal()
  }
)

function closeModal() {
  assinaturaStore.closeBlockedModal()
}

function corrigirInformacoesPagamento() {
  closeModal()
  router.push('/planos/informacoes-de-cobranca')
}
</script>
<style scoped lang="scss">
.rounded-custom {
    border-radius: 0.6rem;
    font-weight: 300;
}
</style>
